import { Component, Input } from '@angular/core';

import { ContextFactory } from '@shared/factories/context/context.factory';

import { ConvertDatePipe } from '../../filters/convert-date/convert-date.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'task-historic',
    templateUrl: './task-historic.component.html',
    standalone: true,
    imports: [NgClass, AfTranslateDirective, AfOrderByPipe, ConvertDatePipe]
})

export class TaskHistoricComponent{
  taskHistoric: any = {
    showCommentList: true,
    readMore: true,
    readMoreText:false,
    noComments: true,
    fullScreen: false,
    compareVersions: {
      jwtToken: this.context.jwtToken,
      logID: null,
      taskId: null
    }
  }

  constructor(private context: ContextFactory) {}

  @Input() historicList:any = [];
  @Input() task:any = null

  comparatorInfo(historic:any){
    this.taskHistoric.compareVersions.logID = historic.logOperationID;
    this.taskHistoric.compareVersions.taskId = this.task.taskId;
  }
}
